import {LangKeyType} from '../../../../../../../provider/locale/translation/type';

export enum CategoryFromGalleryFormItemEnum {
    All = 'all',
    Video = 'video',
}

export const categoryFromGalleryList: Array<{key: CategoryFromGalleryFormItemEnum; label: LangKeyType}> = [
    {key: CategoryFromGalleryFormItemEnum.All, label: 'TAGS__TAG_TYPE__ALL'},
    {key: CategoryFromGalleryFormItemEnum.Video, label: 'POSTS_FORM__VIDEO'},
];

const BYTES_IN_MEGABYTE = 1024 * 1024;

/**
 * Yandex video requirements — the only catalog that accepts video for now.
 * Keep them in one place so they can become per-catalog once video ships to Google (DEV-19376).
 */
export const VIDEO_CONSTRAINTS = {
    maxDurationSec: 60,
    maxSizeByte: 100 * BYTES_IN_MEGABYTE,
    minResolution: 360,
    maxResolution: 1080,
};

export const ACCEPTED_IMAGE_FORMATS = 'image/jpeg, image/jpg, image/png, image/gif';

export const ACCEPTED_VIDEO_FORMATS = 'video/mp4, video/quicktime, .mp4, .mov';
